import React from 'react';
import Message from './Message';

const MessageList = ({
  messages,
  isLoading,
  messagePage,
  isTyping,
  chatName,
  senderId,
  containerRef,
  endRef,
}) => {
  return (
    <div
      ref={containerRef}
      className="flex-1 overflow-y-auto p-2 text-sm text-gray-700 space-y-2"
    >
      {isLoading && messagePage === 0 ? (
        <div className="flex justify-center py-4">Loading messages...</div>
      ) : messages.length === 0 ? (
        <div className="text-center py-4 text-gray-500">
          No messages yet. Start a conversation!
        </div>
      ) : (
        <>
          {isLoading && messagePage > 0 && (
            <div className="text-center py-2 text-xs text-gray-500">
              Loading older messages...
            </div>
          )}
          {messages.map((msg, index) => (
            <Message
              key={msg.id || index}
              message={msg}
              isSender={msg.senderId === senderId}
            />
          ))}
          {isTyping && (
            <div className="text-xs text-gray-500 italic p-2">
              {chatName} is typing...
            </div>
          )}
        </>
      )}
      <div ref={endRef} />
    </div>
  );
};

export default MessageList;
